<template>
    <v-container pa-0 style="max-width: 100% !important">
        <v-data-table class="wrap-headers" :headers="table_headers" :items="['1']" hide-actions>
            <template slot="items">
                <tr v-for="(log, index) in logs">
                    <td>{{ log.date_created }}</td>
                    <!-- <td>{{ item[header] }}</td> -->
                    <!-- iterate through all the logs and their log details and get the user value based on the question -->
                    <td v-for="(log_detail, index) in log.logs_detail">
                        {{ log_detail.user_value }}
                    </td>

                    <td>
                        {{ log.created_by }}
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
export default {
    name: "honing_process_check_sheet_table",
    props: {
        slug: {
            type: String,
            required: true,
        },
        logs: {
            type: Array,
            required: true,
        },
        log_template: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            row_headers: [],
            table_headers: [
                { text: "Date", sortable: false, width: "10%" },
                { text: "Batch No.", sortable: false, width: "5%" },
                { text: "Operating \n Air Pressure", sortable: false, width: "5%", align: "center" },
                { text: "Air Pressure \n Status", sortable: false, width: "5%", align: "center" },
                { text: "Cycle Time \n Setting", sortable: false, width: "5%", align: "center" },
                { text: "Jig Change \n (before work)", sortable: false, width: "30", align: "center" },
                { text: "Parts Name", sortable: false, width: "5%" },
                { text: "Start Time", sortable: false, width: "5%" },
                { text: "End Time", sortable: false, width: "5%" },
                { text: "No. of Done", sortable: false, width: "5%" },
                { text: "No. of Rework", sortable: false, width: "5%" },
                { text: "No. of NG", sortable: false, width: "5%" },
                { text: "Number \n Completed", sortable: false, width: "5%", align: "center" },
                { text: "Remark", sortable: false, width: "5%" },
                { text: "Signature", sortable: false, width: "5%" },
            ],
        };
    },
    computed: {},
};
</script>
<style>
.wrap-headers th {
    white-space: pre !important;
}
</style>
